"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEnumValues = exports.getEnumEntries = void 0;
const getEnumValues = enumObject => {
  const keys = Object.keys(enumObject).filter(item => isNaN(Number(item)));
  return keys.map(key => enumObject[key]);
};
exports.getEnumValues = getEnumValues;
const getEnumEntries = enumObject => {
  const keys = Object.keys(enumObject).filter(item => isNaN(Number(item)));
  return keys.map(key => [key, enumObject[key]]);
};
exports.getEnumEntries = getEnumEntries;
//# sourceMappingURL=enum.js.map